import { Fragment } from 'react'
import { useSelector } from 'react-redux'
import classNames from 'classnames'
import _ from '@strings'
import { formatDate } from '@utils/helpers'
import Icon from '@components/Ui/Icon'
import Button from '@components/Ui/Button'
import Spacer from '@components/Ui/Spacer'
import { useMediaQueryContext } from '@context'
import Text from '@components/Ui/Text'
import { useFieldLabelByValue } from '@hooks'
import styles from './DataReview.scss'

const DataReview = ({ showTitle, showFormData, checked }) => {
  const { md } = useMediaQueryContext()
  const { child, type, store, slot, form, ics } = useSelector((s) => s.data)
  const mode = useSelector((s) => s.data.mode)
  const titleLabel = useFieldLabelByValue('appointment_title', form?.appointment_title || '')

  checked = false

  console.log(type)

  return (
    <Fragment>
      <div className={styles.base}>
        {md && (
          <div className={classNames(styles.icon, { [styles.iconChecked]: checked })}>
            {type?.svg && <div dangerouslySetInnerHTML={{ __html: type?.svg }} />}
            {/*<img src={type?.image} alt="" />*/}
            {checked && (
              <div className={styles.check}>
                <Icon type="check" />
              </div>
            )}
          </div>
        )}
        {showTitle && (
          <Text as="div" type="slab_md">
            {mode === 'live' && _('review.headline_live')}
            {mode !== 'live' && _('review.headline_restricted')}
          </Text>
        )}
        {!showTitle && (
          <Text as="div" type="slab_md">
            {mode === 'live' && _('review.headline_second_live')}
            {mode !== 'live' && _('review.headline_second_restricted')}
          </Text>
        )}

        <Spacer vertical scale="0.5" />

        <Text as="div" type="robo_xmd_bold">
          {_('review.headline_details', {
            type: type?.name,
          })}
        </Text>
        <div className={styles.row}>
          <Icon type="calendar" size="20" />
          <Text as="div">{formatDate(Date.parse(slot?.date), 'eeee, dd. MMMM yyyy')}</Text>
        </div>
        <div className={styles.row}>
          <Icon type="clock" size="20" />
          <Text as="div">
            {slot?.startTime && slot?.endTime && (
              <Fragment>
                {`${slot?.startTime.slice(0, -3)} - ${slot?.endTime.slice(0, -3)}`}{' '}
                {_('datetime.time')}
              </Fragment>
            )}
            {slot?.startTime && slot?.endTime && slot?.prefix ? ` (${slot?.prefix})` : slot?.prefix}
          </Text>
        </div>
        <div className={styles.row}>
          <Icon type="pin" size="20" />
          <Text as="div">
            {`${store.contact.address}, ${store.contact.zip} ${store.contact.city}`}
          </Text>
        </div>
        {child && (
          <div className={styles.row}>
            <Icon type="person" size="20" />
            <Text as="div">{_('review.is_child')}</Text>
          </div>
        )}
        {!child && false && (
          <div className={styles.row}>
            <Icon type="person" size="20" />
            <Text as="div">{_('review.is_grownup')}</Text>
          </div>
        )}
        {mode !== 'live' && (
          <Text as="div" type="robo_md_bold">
            {_('review.confirmation_needed')}
          </Text>
        )}

        {showFormData && (
          <Fragment>
            {(md || ics) && <Spacer vertical scale="1" />}
            <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
              {md && <Button onClick={() => window.print()}>{_('review.button_print')}</Button>}
              {ics && (
                <a href={ics} rel="noreferrer">
                  <Button>{_('review.button_calendar')}</Button>
                </a>
              )}
            </div>
          </Fragment>
        )}
      </div>

      {showFormData && (
        <Fragment>
          <Spacer vertical scale="1" />
          <div className={styles.base}>
            <Text as="div" type="robo_md_bold">
              {_('review.your_data')}
            </Text>
            <Text as="div">
              {/* eslint-disable-next-line max-len */}
              {`${titleLabel} ${form.appointment_firstname} ${form.appointment_lastname}`}
              <br />
              {form.appointment_zip && `${form.appointment_zip} ${form.appointment_city}`}
              {!form.appointment_zip && `${form.appointment_birthdate}`}
            </Text>
            <Text as="div">
              {/* eslint-disable-next-line max-len */}
              {`${form.appointment_email} / ${form.appointment_phone_prefix} ${form.appointment_phone}`}
              {form.appointment_mobile && ` / ${form.appointment_mobile}`}
            </Text>
          </div>
        </Fragment>
      )}
    </Fragment>
  )
}

DataReview.defaultProps = {
  showTitle: true,
  checked: false,
}
DataReview.propTypes = {}

export default DataReview
